import { attr } from 'spraypaint';
import ApplicationRecord from './ApplicationRecord';

const ShopOnboarding = ApplicationRecord.extend({
  attrs: {
    first_name: attr({ type: String }),
    last_name: attr({ type: String }),
    marketing_opt_in: attr({ type: Boolean }),
    third_party_marketing_opt_in: attr({ type: Boolean }),
    email: attr({ type: String }),
    password: attr({ type: String }),
    delivery_instructions: attr({ type: String }),
    locality: attr({ type: String }),
    postcode: attr({ type: String }),
    recipient_phone: attr({ type: String }),
    street_1: attr({ type: String }),
    street_2: attr({ type: String }),
  },
  static: {
    endpoint: '/shop_onboardings',
    jsonapiType: 'onboardings-shop_onboardings',
  },
});

export default ShopOnboarding;
